<template>
	<div>
		<v-card-title class="primary--text ma-0 pa-0">
			{{ title }}
			<v-divider class="mx-3" style="margin-top: unset;" vertical inset></v-divider>
		</v-card-title>
		<v-breadcrumbs
			v-if="breadcrumbItems.length > 1 && !showOnlyTitle"
			:items="breadcrumbItems"
			class="px-0 pb-0 pt-2"
		>
			<template v-slot:item="{ item }">
				<v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
					{{ item.text }}
					<v-icon color="primary" v-if="item.icon">{{ item.icon }}</v-icon>
				</v-breadcrumbs-item>
			</template>
		</v-breadcrumbs>
	</div>
</template>

<script>
import { getName, getPath } from "../../../../Router/router";
export default {
	props: {
		showOnlyTitle: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		breadcrumbItems() {
			let breadcrumbs = [
				{
					disabled: false,
					href: "/",
					icon: "home"
				}
			];

			breadcrumbs = breadcrumbs.concat(
				this.$route.path
					.split("/")
					.slice(1, this.$route.path.split("/").length - 1)
					.map((i, index) => {
						return {
							text: Number(i) ? i : getName(i),
							href: getPath(i),
							disabled: index == 1 ? true : false
						};
					})
			);
			return breadcrumbs;
		},
		title() {
			return getName(this.$route.name);
		}
	}
};
</script>
<style scoped>
.theme--light.v-toolbar.v-sheet {
	background-color: inherit;
}
</style>